<template>

  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">员工管理</span>
        <el-button icon="el-icon-plus" style="float:right;" type="primary" size="normal" @click="createClickHandler">添加员工</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="small">
          <el-form-item label="姓名：">
            <el-input clearable v-model="queryInfo.name" placeholder="请输入姓名" @clear="getList" style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select clearable filterable v-model="queryInfo.department" placeholder="请选择部门" @clear="getList" style="width: 180px" @change="getList">
              <el-option v-for="dept in departmentList" :key="dept._id" :label="dept._id" :value="dept._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位：">
            <el-select clearable filterable v-model="queryInfo.job" placeholder="请选择职位" @clear="getList" style="width: 180px" @change="getList">
              <el-option v-for="job in jobList" :key="job" :label="job" :value="job"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间：">
            <el-date-picker
              v-model="inDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              style="width: 240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="queryInfo.status" placeholder="请选择状态" style="width: 120px" @change="getList">
              <el-option label="在职" :value="1"></el-option>
              <el-option label="离职" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="getList">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px">
        <el-table-column label="编号" type="index" width="60px"></el-table-column>
        <el-table-column label="员工信息" width="130px">
          <template slot-scope="scope">
            <div style="font-size: 16px; font-weight: bold;">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex" width="80px"></el-table-column>
        <el-table-column label="部门" prop="department" min-width="140"></el-table-column>
        <el-table-column label="职位" prop="job" min-width="100"></el-table-column>

        <el-table-column label="状态" min-width="80px">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.status === 1" type="success">在职</el-tag>
            <el-tag size="small" v-else type="info">离职</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="入职时间" min-width="120px">
          <template slot-scope="scope">
            {{ formatDate(scope.row.inDate) }}
          </template>
        </el-table-column>
        <el-table-column label="离职时间" min-width="120px">
          <template slot-scope="scope">
            {{ scope.row.outDate ? formatDate(scope.row.outDate) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="250px">
          <template slot-scope="scope">
            <el-button type="primary" plain size="small" @click="modifyClickHandler(scope.row)">修改</el-button>
            <el-button type="warning" plain size="small" @click="quitClickHandler(scope.row)" :disabled="scope.row.status === 0">离职</el-button>
            <el-button v-if="isAdmin" type="danger" plain size="small" @click="cleanClickHandler(scope.row)" :disabled="scope.row.status === 1">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 离职对话框 -->
    <el-dialog
      title="员工离职"
      :visible.sync="quitDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="quit-dialog-content">
        <div class="employee-info">
          <span class="label">员工信息：</span>
          <span class="value">{{ selectedEmployee?.name }} - {{ selectedEmployee?.department }} - {{ selectedEmployee?.job }}</span>
        </div>
        <div class="quit-form">
          <el-form :model="quitForm" :rules="quitFormRules" ref="quitFormRef" label-width="100px">
            <el-form-item label="离职时间" prop="quitDate">
              <el-date-picker
                v-model="quitForm.quitDate"
                type="date"
                placeholder="请选择离职日期"
                value-format="yyyy-MM-dd"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuit">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { systemJobList } from '@/utility/staticData'
import { readLevel } from '@/utility/permissions'
export default {
  data () {
    return {
      // 是否管理员（level<=1）：物理清理按钮仅管理员可见，后端仍是真闸门
      isAdmin: false,
      // 员工列表数据
      list: [],
      // 查询参数
      queryInfo: {
        name: '', // 姓名关键字
        department: '', // 部门
        job: '', // 职位
        inDateStart: '', // 入职开始时间
        inDateEnd: '', // 入职结束时间
        status: 1, // 员工状态：1-在职，0-离职
        pagenum: 1, // 当前页码
        pagesize: 10 // 每页显示数量
      },
      // 总记录数
      total: 0,
      // 部门列表
      departmentList: [],
      // 职位列表
      jobList: systemJobList,
      // 入职时间范围选择器绑定值
      inDateRange: null,

      selectedEmployee: null,

      // 离职对话框可见性
      quitDialogVisible: false,
      // 离职表单数据
      quitForm: {
        quitDate: '' // 离职日期
      },
      // 离职表单验证规则
      quitFormRules: {
        quitDate: [
          { required: true, message: '请选择离职日期', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.isAdmin = readLevel() <= 1
    this.getDepartmentList()
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('system/employee/list', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    // 获取部门列表
    async getDepartmentList () {
      const { data: res } = await this.$http.get('system/department/list')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.departmentList = res.data
    },

    // 处理日期范围变化
    handleDateChange (dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryInfo.inDateStart = dateRange[0]
        this.queryInfo.inDateEnd = dateRange[1]
      } else {
        this.queryInfo.inDateStart = ''
        this.queryInfo.inDateEnd = ''
      }
      this.getList()
    },

    // 重置查询条件
    resetQuery () {
      this.queryInfo.name = ''
      this.queryInfo.department = ''
      this.queryInfo.inDateStart = ''
      this.queryInfo.inDateEnd = ''
      this.queryInfo.status = 1
      this.inDateRange = null
      this.queryInfo.pagenum = 1
      this.queryInfo.job = ''
      this.getList()
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击添加按钮
    async createClickHandler () {
      this.$router.push('/system/employee/add')
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      this.$router.push(`/system/employee/modify/${row._id}`)
    },

    // 点击离职按钮
    async quitClickHandler (row) {
      this.selectedEmployee = row
      // 设置默认离职日期为今天
      this.quitForm.quitDate = this.formatDate(new Date())
      this.quitDialogVisible = true
    },

    // 点击删除按钮
    async cleanClickHandler (row) {
      // 二次确认
      const confirmResult = await this.$confirm(
        `确定要删除员工 ${row.name} 吗？`,
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger',
          dangerouslyUseHTMLString: true
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      try {
        // 调用删除接口
        const { data: res } = await this.$http.delete(`system/employee/clean/${row._id}`)

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('员工删除成功')
        this.getList() // 刷新列表
      } catch (error) {
        console.error('员工删除失败:', error)
        this.$message.error('删除操作失败，请稍后重试')
      }
    },

    // 确认离职
    async confirmQuit () {
      // 表单验证
      this.$refs.quitFormRef.validate(async (valid) => {
        if (!valid) return

        // 二次确认
        const confirmResult = await this.$confirm(
          `确定要将员工 ${this.selectedEmployee.name} 设置为离职状态吗？<br>离职日期：${this.quitForm.quitDate}`,
          '确认离职',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        ).catch((err) => err)

        if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

        try {
          // 调用离职接口
          const { data: res } = await this.$http.delete(`system/employee/remove/${this.selectedEmployee._id}`, {
            data: {
              outDate: this.quitForm.quitDate
            }
          })

          if (res.meta.status !== 200) {
            return this.$message.error(res.meta.msg)
          }

          this.$message.success('员工离职成功')
          this.quitDialogVisible = false
          this.getList() // 刷新列表
        } catch (error) {
          console.error('员工离职失败:', error)
          this.$message.error('离职操作失败，请稍后重试')
        }
      })
    },

    // 格式化日期
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style lang="less" scoped>
/* 离职对话框样式 */
.quit-dialog-content {
  .employee-info {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;

    .label {
      font-weight: bold;
      margin-right: 10px;
    }

    .value {
      color: #606266;
    }
  }

  .quit-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
}
</style>
